export default __webpack_public_path__ + "static/media/plain-sticker-P.0ec0f31e.png";